var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"main_layout"}},[_c('main-navbar'),(_vm.$vuetify.breakpoint.mobile)?_c('drawer'):_vm._e(),_c('v-main',[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }